import {
    SizeLink,
    TypeLink,
} from 'app/shared-components/SkyNetLink/SkyNetLink.enum'

import SkyNetLink from 'app/shared-components/SkyNetLink'
import {
    FailedUploadColumns,
} from 'app/shared-components/BatchActions/components/UploadFeedback/UploadFeedback.types'
import {
    getErrorColumn,
} from 'app/shared-components/BatchActions/components/UploadFeedback'
import {
    LoggerResponse,
} from '../Loggers.types'

const getColumns = (
    {
        l,
        getLoggerLink,
        linkStyles,
    }: {
        l: (key: string) => string,
        getLoggerLink: (loggerNumber: string) => string,
        linkStyles: string,
    },
): FailedUploadColumns<LoggerResponse> => {
    return [
        {
            id: 'loggerNumber',
            headerProps: {
                children: l('Logger.loggerNumber'),
            },
            mapCellProps: ({
                loggerNumber,
            }) => {
                return {
                    value: loggerNumber,
                    link: getLoggerLink(loggerNumber),
                    className: linkStyles,
                    type: TypeLink.EXTERNAL,
                    size: SizeLink.S,
                }
            },
            Cell: SkyNetLink,
            width: '200px',
        },
        getErrorColumn('Logger', l),
    ]
}

export default getColumns
